import axios, { AxiosResponse } from '../../node_modules/axios/index';
import { getApiUrl } from '../constants/api';

export const defaultProductCardUiStyles = {
  wishlistIconSize: '20px',
  wishlistIconColor: '#000000',
  wishlistIcon: '4',
  wishlistIconPosition: 'top-left',
  showWishlistIcon: true,

  // Add to Cart Icon Settings
  showAddToCartIcon: true,
  addToCartIcon: '5',
  addToCartIconColor: '#FFFFFF',
  addToCartIconSize: '20px',

  // Button Settings
  addToCartButtonColor: '#000000',
  addToCartButtonText: 'إضافة للسلة',
  addToCartButtonTextEn: 'Add to Cart',
  addToCartButtonTextColor: '#FFFFFF',
  addToCartButtonHoverColor: '#000000',
  addToCartButtonType: 'filled',
  addToCartButtonWidth: '100%',
  addToCartButtonHeight: '40px',
  addToCartButtonBorderRadius: '0.5rem',
  addToCartButtonOutOfStockText: 'نفد المخزون',
  addToCartButtonOutOfStockTextEn: 'Out of Stock',
  // Card Settings
  productCardBorderRadius: '0.5rem',
  productCardWidth: '200px',
  productCardImageHeight: '200px',
  productCardEnableEnglishPrices: false,

  // Content Settings
  productCardContentPriceColor: '#FF0000',
  productCardContentPriceBeforeDiscountColor: '#000000',
  productCardContentHeight: 'auto',
  productCardContentPadding: '1rem',
  productCardContentBackgroundColor: '#FFFFFF',
  productCardContentBorderColor: '#ffffff',
  productCardContentBorderWidth: '0px',
};

export interface ProductCardSettings {
  uiStyles?: Partial<typeof defaultProductCardUiStyles>;
}

export async function getProductCardSettings(
  storeId: string,
  provider: string,
): Promise<ProductCardSettings> {
  const response: AxiosResponse = await axios.get(
    `${getApiUrl(
      storeId,
    )}/stores/${storeId}/product-card-settings?storeType=${provider}`,
  );

  // Merge the API response with default values, only taking the uiStyles
  return {
    uiStyles: {
      ...defaultProductCardUiStyles,
      ...(response.data?.uiStyles || {}),
    },
  };
}
